export const logsConstants = {
    GET_AGENT_CREATED_LOGS_SUCCESS: 'GET_AGENT_CREATED_LOGS_SUCCESS',
    GET_LOGS_FAILURE: 'GET_LOGS_FAILURE',
    GET_LOGS_LOADING:"GET_LOGS_LOADING"
};
